import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import React from 'react';

const structuredData = {
  "@context": "https://schema.org",
  "@type": "OfferCatalog",
  "name": "Background Check Services FAQ",
  "url": "https://www.homecarechecks.com/faq",
  "provider": {
    "@type": "Organization",
    "name": "RealTech LLC",
    "url": "https://www.homecarechecks.com"
  }
};

export default function Pricing() {
  return (
    <main>
	<Header
  title="Frequently Asked Questions"
  description="Fast answers for busy agency owners, franchise operators, and compliance teams."
  structuredData={structuredData}
/>
<HeroSection
  heading="Got Questions - We Have Answers"
  subheading="Background Checks Made Simple for Homecare Agencies"
  tagline="Clear answers to help you stay compliant, protect clients, and hire with confidence"
/>
 <section id="faqs" className="features">
  <h2>Homecare Background Check FAQs</h2>
  <p><em>Fast answers for busy agency owners, franchise operators, and compliance teams.</em></p>

  <details>
    <summary><strong>Why do homecare agencies need background checks?</strong></summary>
    <p>
      Background checks help protect vulnerable clients and keep your agency compliant with
      state and Medicaid waiver requirements by screening for criminal history, license validity,
      and healthcare exclusions.
    </p>
  </details>

  <details>
    <summary><strong>What types of checks are included?</strong></summary>
    <p>
      Common checks include a 7-year criminal history search, abuse/neglect registries,
      OIG/HHS and SAM exclusions, state license & nurse aide registry verification,
      optional Motor Vehicle Reports (MVR), and continuous criminal monitoring.
    </p>
  </details>

  <details>
    <summary><strong>How often should I re-run checks?</strong></summary>
    <p>
      <strong>Pre-hire</strong> for every caregiver, <strong>annually</strong> for compliance,
      and <strong>continuous monitoring</strong> for real-time alerts between yearly rechecks.
    </p>
  </details>

  <details>
    <summary><strong>Will background checks slow down hiring?</strong></summary>
    <p>
      No. Most results return instantly or at worst in minutes.
    </p>
  </details>

  <details>
    <summary><strong>What is Continuous Criminal Monitoring?</strong></summary>
    <p>
      Instead of a one-time snapshot, continuous monitoring sends alerts if a caregiver
      is arrested or convicted—helping you respond quickly and stay compliant between annual checks.
    </p>
  </details>

  <details>
    <summary><strong>Are background checks required by law?</strong></summary>
    <p>
      In many states, yes. Medicaid waiver programs and state licensing bodies typically
      require criminal, exclusion, and abuse registry checks. Requirements vary by state.
    </p>
  </details>

  <details>
    <summary><strong>What if someone appears on an exclusion list?</strong></summary>
    <p>
      Individuals on OIG/SAM/Medicaid exclusion lists are ineligible to work with federally
      funded programs. Agencies must remove or reassign them to avoid penalties.
    </p>
  </details>

  <details>
    <summary><strong>Do you cover multiple states?</strong></summary>
    <p>
      Yes. We include national databases and state-specific registries based on
      where your caregivers live and work.
    </p>
  </details>

  <details>
    <summary><strong>How much does it cost?</strong></summary>
    <p>
      Pricing is per check—e.g., a 7-year criminal history is typically $15,
      registry checks from $0.45, and continuous monitoring ~$20 per caregiver per year. 
      <a href="/pricing" >See our transparent pricing for details.</a>
    </p>
  </details>

  <details>
    <summary><strong>How do you help with compliance and audits?</strong></summary>
    <p>
      FortiTeam automates schedules, reminders, and reporting. All results are stored
      securely and are audit-ready—no spreadsheets or manual trackers required. If you need us to run these for you we can and will price that as a separate service.
    </p>
  </details>

  <div style={{ marginTop: '1.5rem' }}>
    <a href="/pricing" className="btn">See Transparent Pricing</a>
  </div>
</section>

    </main>
  );
}
